import { createSlice } from '@reduxjs/toolkit';
import { getEventStatusListThunk } from './EventStatus.thunk';

export const eventStatusSlice = createSlice({
  name: 'eventStatus',
  initialState: {
    list: {
      items: [],
      loading: true,
      pagination: {},
    },
  },
  reducers: {
    //
  },
  extraReducers: builder => {
    // Start EventStatus list
    builder.addCase(getEventStatusListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getEventStatusListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = _pagination
        ? {
            currentPage: _pagination.current_page,
            lastPage: _pagination.last_page,
            total: _pagination.total,
          }
        : {};
      state.list = { ...state.list, items: data, pagination, loading: false };
    });
    builder.addCase(getEventStatusListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End EventStatus list
  },
});

export const getEventStatusList = (state: any) => state.eventStatus.list;

export default eventStatusSlice.reducer;
